import axios from 'axios';

// Configure axios defaults
// const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://production-env.eba-ciq8sru9.eu-north-1.elasticbeanstalk.com/api';

const API_BASE_URL = 'https://api.absportsacademy.in/api';
// const API_BASE_URL = 'http://localhost:8080/api'

export const authAPI = {
  login: async (credentials) => {
    const response = await api.post('/admin/login', credentials);
    return response;
  },

  logout: async () => {
    const response = await api.post('/admin/logout');
    return response;
  },

  getProfile: async () => {
    const response = await api.get('/admin/profile');
    return response;
  },
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const dashboardAPI = {
  getMetrics: async () => {
    const response = await api.get('/admin/dashboard/metrics');
    return response;
  },

  getRecentBookings: async () => {
    const response = await api.get('/admin/dashboard/recent-bookings');
    return response;
  },

  getBookingTrend: async (params = {}) => {
    const response = await api.get('/admin/dashboard/booking-trend', { params });
    return response;
  },

  getRevenueBySport: async (params = {}) => {
    const response = await api.get('/admin/dashboard/revenue-by-sport', { params });
    return response;
  },
};

export const courtsAPI = {
  getAll: async (params = {}) => {
    const response = await api.get('/admin/courts', { params });
    return response;
  },

  getById: async (id) => {
    const response = await api.get(`/admin/courts/${id}`);
    return response;
  },

  create: async (courtData) => {
    const response = await api.post('/admin/courts', courtData);
    return response;
  },

  update: async (id, courtData) => {
    const response = await api.put(`/admin/courts/${id}`, courtData);
    return response;
  },

  delete: async (id) => {
    const response = await api.delete(`/admin/courts/${id}`);
    return response;
  },
};

export const sportsAPI = {
  getAll: async () => {
    const response = await api.get('/admin/sports');
    return response;
  },

  getById: async (id) => {
    const response = await api.get(`/admin/sports/${id}`);
    return response;
  },

  create: async (sportData) => {
    const response = await api.post('/admin/sports', sportData);
    return response;
  },

  update: async (id, sportData) => {
    const response = await api.put(`/admin/sports/${id}`, sportData);
    return response;
  },

  delete: async (id) => {
    const response = await api.delete(`/admin/sports/${id}`);
    return response;
  },
};

export const bookingsAPI = {
  getAll: async (params = {}) => {
    const response = await api.get('/admin/bookings', { params });
    return response;
  },

  exportCSV: async (params = {}) => {
    const response = await api.get('/admin/bookings/export', {
      params,
      responseType: 'blob',
    });
    return response;
  },

  getById: async (id) => {
    const response = await api.get(`/admin/bookings/${id}`);
    return response;
  },

  createWalkIn: async (bookingData) => {
    const response = await api.post('/admin/bookings/walk-in', bookingData);
    return response;
  },

  getAvailableSlots: async (sportId, date) => {
    const response = await api.get('/admin/bookings/available-slots', { params: { sport_id: sportId, date } });
    return response;
  },

  updateStatus: async (bookingId, newStatus) => {
    const response = await api.patch(`/admin/bookings/${bookingId}/status`, { status: newStatus });
    return response;
  },

  cancel: async (bookingId, reason) => {
    const response = await api.patch(`/admin/bookings/${bookingId}/cancel`, { reason });
    return response;
  },
};

export const usersAPI = {
  getAll: async (params = {}) => {
    const response = await api.get('/admin/users', { params });
    return response;
  },

  getById: async (id) => {
    const response = await api.get(`/admin/users/${id}`);
    return response;
  },

  updateStatus: async (id, status) => {
    const response = await api.put(`/admin/users/${id}/status`, { status });
    return response;
  },
};